import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=55bc1f82&scoped=true&"
import script from "./AppCenter.vue?vue&type=script&lang=js&"
export * from "./AppCenter.vue?vue&type=script&lang=js&"
import style0 from "./AppCenter.vue?vue&type=style&index=0&id=55bc1f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc1f82",
  null
  
)

export default component.exports